import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';

const PrivacyPolicyPage = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
      Privacy Policy
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Ultimo aggiornamento: maggio 2025
    </Typography>
    <Divider sx={{ my: 3 }} />

    <Section title="1. Titolare del Trattamento">
      <p>Il Titolare del trattamento dei dati personali è:</p>
      <p>
        <strong>Forasassi Lucia</strong> (commerciante individuale, nome commerciale: WatchPassion)<br />
        P.IVA: 01813530514<br />
        Email: <Link href="mailto:Info@watchpassion.net">Info@watchpassion.net</Link>
      </p>
    </Section>

    <Section title="2. Dati raccolti e finalità">
      <p>Il sito raccoglie i seguenti dati personali:</p>
      <ul>
        <li><strong>Dati di contatto</strong> (nome, email, numero di telefono): forniti volontariamente tramite il form di contatto, al fine di rispondere alle richieste dell'utente. Base giuridica: esecuzione di misure precontrattuali (Art. 6.1.b GDPR).</li>
        <li><strong>Dati di navigazione</strong> (indirizzo IP, browser, pagine visitate): raccolti automaticamente dai server per il corretto funzionamento del sito. Base giuridica: legittimo interesse (Art. 6.1.f GDPR).</li>
        <li><strong>Cookie</strong>: vedere la Cookie Policy per i dettagli.</li>
      </ul>
    </Section>

    <Section title="3. Conservazione dei dati">
      <p>I dati raccolti tramite il form di contatto sono conservati per un massimo di <strong>24 mesi</strong> dalla ricezione, salvo diversi obblighi di legge. I dati di navigazione sono conservati per un massimo di 12 mesi.</p>
    </Section>

    <Section title="4. Destinatari dei dati">
      <p>I dati non vengono venduti né ceduti a terzi. Potrebbero essere trasmessi a fornitori tecnici (es. provider di hosting) che agiscono in qualità di Responsabili del Trattamento ai sensi dell'Art. 28 GDPR, con adeguate garanzie contrattuali.</p>
    </Section>

    <Section title="5. Diritti dell'interessato">
      <p>L'utente ha il diritto di:</p>
      <ul>
        <li>Accedere ai propri dati personali (Art. 15 GDPR)</li>
        <li>Rettificare i dati inesatti (Art. 16 GDPR)</li>
        <li>Richiedere la cancellazione dei dati (Art. 17 GDPR)</li>
        <li>Richiedere la limitazione del trattamento (Art. 18 GDPR)</li>
        <li>Ricevere i dati in formato portabile (Art. 20 GDPR)</li>
        <li>Opporsi al trattamento (Art. 21 GDPR)</li>
        <li>Revocare il consenso in qualsiasi momento (Art. 7 GDPR)</li>
      </ul>
      <p>Per esercitare i propri diritti, l'utente può scrivere a: <Link href="mailto:Info@watchpassion.net">Info@watchpassion.net</Link></p>
      <p>L'utente ha inoltre il diritto di proporre reclamo al <Link href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">Garante per la Protezione dei Dati Personali</Link>.</p>
    </Section>

    <Section title="6. Trasferimenti internazionali">
      <p>I dati non sono trasferiti al di fuori dello Spazio Economico Europeo, salvo diversa comunicazione e nel rispetto delle garanzie previste dal GDPR.</p>
    </Section>

    <Section title="7. Modifiche alla presente informativa">
      <p>Il Titolare si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione della data di aggiornamento.</p>
    </Section>
  </Container>
);

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>{title}</Typography>
    <Typography variant="body1" component="div" color="text.secondary" sx={{ lineHeight: 1.8 }}>
      {children}
    </Typography>
  </Box>
);

export default PrivacyPolicyPage;
